const FETCH_RELATED_LISTING = 'related_listings/FETCH_RELATED_LISTING';
const FETCH_RELATED_LISTING_SUCCESS = 'related_listings/FETCH_RELATED_LISTING_SUCCESS';
const FETCH_RELATED_LISTING_FAILURE = 'related_listings/FETCH_RELATED_LISTING_FAILURE';

export default {
  FETCH_RELATED_LISTING,
  FETCH_RELATED_LISTING_SUCCESS,
  FETCH_RELATED_LISTING_FAILURE,
};